import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { AUTH_ACTION_TYPE, SessionSelector } from "@obg/ngx.core";
import { timer } from "rxjs";
import { filter, map, switchMap, tap, withLatestFrom } from "rxjs/operators";

import { CommonState } from "../../state";

import { HardSessionConfigService } from "./hard-session.config";
import { HardSessionService } from "./hard-session.service";

@Injectable()
export class HardSessionEffect {
	hardSessionPollingStart$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(AUTH_ACTION_TYPE.sessionStart),
				filter(() => !!this.config.getHardSessionLimitIsEnabled()),
				switchMap(() => this.service.checkRemainingHardSessionDuration$()),
				switchMap((remainingSessionTime) =>
					timer(
						0,
						remainingSessionTime < this.config.getHardSessionPollingInterval()
							? remainingSessionTime
							: this.config.getHardSessionPollingInterval()
					).pipe(
						withLatestFrom(this.store.select(this.sessionSelector.isAuthenticated())),
						filter(([, isAuthenticated]) => isAuthenticated),
						switchMap(() =>
							this.service.checkRemainingHardSessionDuration$().pipe(
								filter(
									(hardSessionDuration) =>
										hardSessionDuration <= this.config.getNotificationBeforeLogoutTime() &&
										!this.service.getIsAlertShown
								),
								switchMap((hardSessionDuration) =>
									this.service.showHardSessionNotification$(hardSessionDuration)
								)
							)
						)
					)
				)
			),
		{ dispatch: false }
	);

	hardSessionEnd$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(AUTH_ACTION_TYPE.sessionEnd),
				tap(() => (this.service.setIsAlertShown = false)),
				map(() => undefined)
			),
		{ dispatch: false }
	);

	constructor(
		private actions$: Actions,
		private service: HardSessionService,
		private config: HardSessionConfigService,
		private sessionSelector: SessionSelector,
		private store: Store<CommonState>
	) {}
}
